(function () {
  'use strict';

  if (window.KootaTracking) return;

  var VERSION = '1.0.0';
  var ATTRIBUTION_KEY = 'koota_attribution_v1';
  var SESSION_KEY = 'koota_tracking_session_v1';
  var INTERNAL_SOURCE_KEY = 'koota_internal_source_v1';
  var STORAGE_DAYS = 90;
  var CAMPAIGN_KEYS = [
    'utm_id',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'utm_source_platform'
  ];
  var CLICK_ID_KEYS = [
    'gclid',
    'dclid',
    'gbraid',
    'wbraid',
    'fbclid',
    'msclkid',
    'ttclid',
    'twclid',
    'li_fat_id',
    'srsltid',
    'epik',
    'ScCid',
    'rdt_cid',
    'irclickid',
    'gad_source',
    'gad_campaignid'
  ];
  var PII_KEYS = {
    email: true,
    phone: true,
    first_name: true,
    last_name: true,
    address: true,
    customer_id: true
  };
  var context = window.KootaTrackingContext || {};
  var attribution = null;
  var currentTouch = readTouch();
  var lastVisibleSection = null;
  var viewedSections = {};
  var scrollDepths = {};
  var engagementSent = {};
  var initialized = false;

  function clean(value, maxLength) {
    return String(value === undefined || value === null ? '' : value)
      .replace(/[\u0000-\u001f\u007f]/g, '')
      .trim()
      .slice(0, maxLength || 300);
  }

  function safeUrl(value) {
    try {
      var url = new URL(value, window.location.origin);
      return url.origin + url.pathname;
    } catch (error) {
      return '';
    }
  }

  function randomId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
  }

  function safeParse(value) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function storageGet(key, session) {
    try {
      return (session ? window.sessionStorage : window.localStorage).getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(key, value, session) {
    try {
      (session ? window.sessionStorage : window.localStorage).setItem(key, value);
      return true;
    } catch (error) {
      return false;
    }
  }

  function analyticsAllowed() {
    var custom = window.KootaConsent && typeof window.KootaConsent.get === 'function'
      ? window.KootaConsent.get()
      : null;
    if (custom && custom.hasChoice) return custom.choices.analytics === true;

    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy && typeof privacy.analyticsProcessingAllowed === 'function') {
      try {
        return privacy.analyticsProcessingAllowed() === true;
      } catch (error) {
        return false;
      }
    }
    return false;
  }

  function marketingAllowed() {
    var custom = window.KootaConsent && typeof window.KootaConsent.get === 'function'
      ? window.KootaConsent.get()
      : null;
    if (custom && custom.hasChoice) return custom.choices.marketing === true;

    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (privacy && typeof privacy.marketingAllowed === 'function') {
      try {
        return privacy.marketingAllowed() === true;
      } catch (error) {
        return false;
      }
    }
    return false;
  }

  function loadGTM() {
    var containerId = clean(context.gtm_container_id, 32);
    if (context.tracking_enabled === false || !analyticsAllowed() || !/^GTM-[A-Z0-9]+$/i.test(containerId)) return;
    if (
      document.querySelector('script[src*="googletagmanager.com/gtm.js?id=' + containerId + '"]') ||
      (window.google_tag_manager && window.google_tag_manager[containerId])
    ) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtm.js?id=' + encodeURIComponent(containerId);
    script.setAttribute('data-koota-gtm', containerId);
    document.head.appendChild(script);
  }

  function readTouch() {
    var params = new URLSearchParams(window.location.search);
    var touch = {
      landing_path: clean(window.location.pathname, 500),
      referrer: clean(safeUrl(document.referrer), 500),
      captured_at: new Date().toISOString()
    };
    var hasCampaign = false;

    CAMPAIGN_KEYS.concat(CLICK_ID_KEYS).forEach(function (key) {
      var value = params.get(key);
      if (!value) return;
      touch[key] = clean(value, 180);
      hasCampaign = true;
    });

    if (!hasCampaign) {
      var referrerHost = '';
      try {
        referrerHost = document.referrer ? new URL(document.referrer).hostname : '';
      } catch (error) {
        referrerHost = '';
      }
      if (referrerHost && referrerHost !== window.location.hostname) {
        touch.utm_source = clean(referrerHost.replace(/^www\./, ''), 180);
        touch.utm_medium = 'referral';
      } else {
        touch.utm_source = '(direct)';
        touch.utm_medium = '(none)';
      }
    }

    return touch;
  }

  function storedAttribution() {
    if (!analyticsAllowed()) return null;
    var record = safeParse(storageGet(ATTRIBUTION_KEY, false));
    if (!record || !record.expires_at || Date.parse(record.expires_at) <= Date.now()) return null;
    return record;
  }

  function hasExplicitCampaign(touch) {
    return CAMPAIGN_KEYS.concat(CLICK_ID_KEYS).some(function (key) {
      return Boolean(touch && touch[key]);
    });
  }

  function buildAttribution() {
    var record = storedAttribution();
    var now = Date.now();
    var expires = new Date(now + STORAGE_DAYS * 24 * 60 * 60 * 1000).toISOString();

    if (!record) {
      record = {
        version: VERSION,
        firstTouch: currentTouch,
        lastTouch: currentTouch,
        expires_at: expires
      };
    } else if (hasExplicitCampaign(currentTouch)) {
      record.lastTouch = currentTouch;
      record.expires_at = expires;
    }

    if (!marketingAllowed()) {
      [record.firstTouch, record.lastTouch].forEach(function (touch) {
        CLICK_ID_KEYS.forEach(function (key) {
          if (touch) delete touch[key];
        });
      });
    }

    attribution = record;
    if (analyticsAllowed()) storageSet(ATTRIBUTION_KEY, JSON.stringify(record), false);
    return record;
  }

  function sessionId() {
    var id = storageGet(SESSION_KEY, true);
    if (!id) {
      id = randomId();
      storageSet(SESSION_KEY, id, true);
    }
    return id;
  }

  function internalSource() {
    var source = safeParse(storageGet(INTERNAL_SOURCE_KEY, true));
    if (!source || !source.captured_at || Date.now() - Date.parse(source.captured_at) > 30 * 60 * 1000) {
      return null;
    }
    return source;
  }

  function storeInternalSource(section, element, href) {
    if (!href || href.charAt(0) === '#' || /^mailto:|^tel:|^javascript:/i.test(href)) return;
    var url;
    try {
      url = new URL(href, window.location.origin);
    } catch (error) {
      return;
    }
    if (url.origin !== window.location.origin) return;
    storageSet(INTERNAL_SOURCE_KEY, JSON.stringify({
      section_id: section.id,
      section_name: section.name,
      section_type: section.type,
      section_index: section.index,
      element_text: element.element_text,
      product_handle: element.product_handle,
      destination_path: url.pathname,
      captured_at: new Date().toISOString()
    }), true);
  }

  function sanitizePayload(value, depth) {
    if (depth > 5) return undefined;
    if (Array.isArray(value)) {
      return value.slice(0, 50).map(function (item) {
        return sanitizePayload(item, depth + 1);
      });
    }
    if (value && typeof value === 'object') {
      var output = {};
      Object.keys(value).slice(0, 80).forEach(function (key) {
        if (PII_KEYS[String(key).toLowerCase()]) return;
        var sanitized = sanitizePayload(value[key], depth + 1);
        if (sanitized !== undefined) output[key] = sanitized;
      });
      return output;
    }
    if (typeof value === 'string') return clean(value, 500);
    if (typeof value === 'number' || typeof value === 'boolean') return value;
    return undefined;
  }

  function attributionFields() {
    var record = attribution || buildAttribution();
    var first = record && record.firstTouch || currentTouch;
    var last = record && record.lastTouch || currentTouch;
    var fields = {};

    CAMPAIGN_KEYS.concat(CLICK_ID_KEYS).forEach(function (key) {
      if (first && first[key]) fields['first_' + key] = first[key];
      if (last && last[key]) fields['last_' + key] = last[key];
    });
    fields.first_landing_path = first && first.landing_path;
    fields.last_landing_path = last && last.landing_path;
    fields.first_referrer = first && first.referrer;
    return fields;
  }

  function eventEnvelope(name, parameters) {
    var origin = internalSource();
    return Object.assign(
      {
        event: clean(name, 80),
        event_id: randomId(),
        tracking_version: VERSION,
        event_timestamp: new Date().toISOString(),
        page_type: context.page_type,
        template_name: context.template_name,
        template_suffix: context.template_suffix,
        page_path: clean(window.location.pathname, 500),
        currency: context.currency,
        language: context.language,
        country: context.country,
        resource_id: context.resource_id ? String(context.resource_id) : undefined,
        resource_handle: context.resource_handle,
        customer_logged_in: Boolean(context.customer_logged_in),
        device_type: window.matchMedia('(max-width: 749px)').matches
          ? 'mobile'
          : window.matchMedia('(max-width: 989px)').matches
            ? 'tablet'
            : 'desktop',
        session_id: sessionId(),
        last_section_id: lastVisibleSection && lastVisibleSection.id,
        last_section_name: lastVisibleSection && lastVisibleSection.name,
        origin_section_id: origin && origin.section_id,
        origin_section_name: origin && origin.section_name,
        origin_section_type: origin && origin.section_type,
        origin_section_index: origin && origin.section_index,
        origin_element_text: origin && origin.element_text,
        origin_product_handle: origin && origin.product_handle
      },
      attributionFields(),
      sanitizePayload(parameters || {}, 0)
    );
  }

  function emit(name, parameters) {
    if (context.tracking_enabled === false || !analyticsAllowed()) {
      return false;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventEnvelope(name, parameters));
    return true;
  }

  function flush() {
    if (!analyticsAllowed()) return;
    loadGTM();
    buildAttribution();
    syncCartAttribution();
  }

  function sectionInfo(element) {
    var wrapper = element && element.closest ? element.closest('.shopify-section') : null;
    if (!wrapper) return { id: context.page_type || 'page', name: document.title, index: -1 };
    var heading = wrapper.querySelector('h1, h2, h3');
    var child = wrapper.firstElementChild;
    var className = child && clean(child.className, 160).split(/\s+/)[0];
    var allSections = Array.prototype.slice.call(document.querySelectorAll('.shopify-section'));
    return {
      id: clean(wrapper.id.replace(/^shopify-section-/, ''), 120),
      name: clean(heading && heading.textContent || className || wrapper.id, 160),
      type: clean(child && (child.dataset.sectionType || className) || '', 120),
      index: allSections.indexOf(wrapper)
    };
  }

  function elementInfo(element) {
    var link = element.closest('a, button, summary, input, select, video');
    if (!link) return null;
    var text = link.getAttribute('aria-label') || link.getAttribute('title') || link.textContent || link.name || link.type;
    var href = link.tagName === 'A' ? link.getAttribute('href') : '';
    var productMatch = href && href.match(/\/products\/([^?#/]+)/);
    return {
      element_type: link.tagName.toLowerCase(),
      element_text: clean(text, 160),
      element_id: clean(link.id, 120),
      element_classes: clean(link.className, 180),
      destination_path: href ? clean(safeUrl(href).replace(window.location.origin, ''), 500) : undefined,
      product_handle: productMatch ? productMatch[1] : undefined
    };
  }

  function setupSections() {
    var sections = Array.prototype.slice.call(document.querySelectorAll('.shopify-section'));
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach(function (section) {
        var info = sectionInfo(section);
        emit('koota_section_view', info);
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.35) return;
        var info = sectionInfo(entry.target);
        lastVisibleSection = info;
        if (!viewedSections[info.id]) {
          viewedSections[info.id] = true;
          emit('koota_section_view', Object.assign({ visibility_ratio: Math.round(entry.intersectionRatio * 100) }, info));
        }
      });
    }, { threshold: [0.35, 0.65], rootMargin: '-5% 0px -5% 0px' });

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  function cartItems(cart) {
    return (cart.items || []).map(function (item) {
      return {
        item_id: String(item.product_id || ''),
        item_variant: String(item.variant_id || ''),
        item_name: item.product_title || item.title || '',
        item_brand: item.vendor || 'Koota',
        item_category: item.product_type || '',
        price: Number(item.final_price || item.price || 0) / 100,
        quantity: Number(item.quantity || 1)
      };
    });
  }

  function trackCheckout() {
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        emit('koota_checkout_click', {
          ecommerce: {
            currency: context.currency,
            value: Number(cart.total_price || 0) / 100,
            items: cartItems(cart)
          }
        });
      })
      .catch(function () {
        emit('koota_checkout_click', {});
      });
  }

  function setupInteractions() {
    document.addEventListener('click', function (event) {
      var info = elementInfo(event.target);
      if (!info) return;
      var section = sectionInfo(event.target);

      emit('koota_section_click', Object.assign({}, section, info));

      var target = event.target.closest('a, button');
      var href = target && target.getAttribute('href') || '';
      var label = clean(target && (target.getAttribute('aria-label') || target.textContent), 160).toLowerCase();

      if (target && target.tagName === 'A') storeInternalSource(section, info, href);

      if (
        (target && target.matches('[name="checkout"], [data-checkout], .cart__checkout')) ||
        href.indexOf('/checkout') !== -1
      ) {
        trackCheckout();
      }

      if (target && (target.matches('[data-kq-start], [data-kq-add], [data-koota-cta]') || target.classList.contains('button'))) {
        emit('koota_cta_click', Object.assign({}, section, info));
      }

      if (/suivant|précédent|next|previous|pause|lecture|play/.test(label)) {
        emit('koota_carousel_control', Object.assign({ control: label }, section));
      }
    }, true);

    document.addEventListener('toggle', function (event) {
      if (!event.target.matches('details')) return;
      emit(event.target.open ? 'koota_accordion_open' : 'koota_accordion_close', Object.assign(
        {},
        sectionInfo(event.target),
        { accordion_title: clean(event.target.querySelector('summary') && event.target.querySelector('summary').textContent, 180) }
      ));
    }, true);

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (target.matches('select[name*="sort"], input[name*="filter"], .facets input, .facets select')) {
        emit('koota_filter_change', Object.assign({}, sectionInfo(target), {
          filter_name: clean(target.name, 120),
          filter_value: target.type === 'checkbox' ? String(target.checked) : clean(target.value, 120)
        }));
      }
    }, true);

    document.addEventListener('play', function (event) {
      if (event.target.tagName === 'VIDEO') {
        emit('video_start', Object.assign({}, sectionInfo(event.target), {
          video_id: clean(event.target.id || event.target.currentSrc, 180)
        }));
      }
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = clean(form.getAttribute('action'), 300);
      var section = sectionInfo(form);
      var formType = action.indexOf('/cart/add') !== -1
        ? 'add_to_cart'
        : action.indexOf('/search') !== -1
          ? 'search'
          : action.indexOf('/contact') !== -1
            ? 'contact_or_newsletter'
            : 'other';

      if (formType === 'add_to_cart') {
        var source = {
          section_id: section.id,
          section_name: section.name,
          section_type: section.type,
          section_index: section.index,
          element_text: 'add_to_cart_form',
          destination_path: window.location.pathname,
          captured_at: new Date().toISOString()
        };
        storageSet(INTERNAL_SOURCE_KEY, JSON.stringify(source), true);
        [
          ['properties[_koota_origin_section]', section.id],
          ['properties[_koota_origin_section_name]', section.name],
          ['properties[_koota_tracking_session]', sessionId()]
        ].forEach(function (field) {
          var input = form.querySelector('input[name="' + field[0] + '"]');
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = field[0];
            form.appendChild(input);
          }
          input.value = clean(field[1], 160);
        });
      }

      emit('koota_form_submit_attempt', Object.assign({}, section, {
        form_id: clean(form.id, 120),
        form_action: action,
        form_type: formType
      }));
    }, true);
  }

  function setupScrollAndEngagement() {
    var thresholds = [25, 50, 75, 90];
    var onScroll = function () {
      var height = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
      var depth = Math.min(100, Math.round((window.scrollY / height) * 100));
      thresholds.forEach(function (threshold) {
        if (depth >= threshold && !scrollDepths[threshold]) {
          scrollDepths[threshold] = true;
          emit('scroll', { percent_scrolled: threshold });
        }
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });

    [10, 30, 60, 120].forEach(function (seconds) {
      window.setTimeout(function () {
        if (!document.hidden && !engagementSent[seconds]) {
          engagementSent[seconds] = true;
          emit('koota_engaged_time', { engaged_seconds: seconds });
        }
      }, seconds * 1000);
    });
  }

  function syncCartAttribution() {
    if (!analyticsAllowed() || storageGet('koota_cart_attribution_synced', true)) return;
    var record = attribution || buildAttribution();
    if (!record) return;
    var first = record.firstTouch || {};
    var last = record.lastTouch || {};
    var origin = internalSource() || {};
    var attributes = {
      _koota_ft_source: first.utm_source || '',
      _koota_ft_medium: first.utm_medium || '',
      _koota_ft_campaign: first.utm_campaign || '',
      _koota_ft_id: first.utm_id || '',
      _koota_ft_content: first.utm_content || '',
      _koota_ft_term: first.utm_term || '',
      _koota_ft_platform: first.utm_source_platform || '',
      _koota_ft_landing: first.landing_path || '',
      _koota_lt_source: last.utm_source || '',
      _koota_lt_medium: last.utm_medium || '',
      _koota_lt_campaign: last.utm_campaign || '',
      _koota_lt_id: last.utm_id || '',
      _koota_lt_content: last.utm_content || '',
      _koota_lt_term: last.utm_term || '',
      _koota_lt_platform: last.utm_source_platform || '',
      _koota_origin_section: origin.section_id || '',
      _koota_origin_section_name: origin.section_name || '',
      _koota_origin_element: origin.element_text || '',
      _koota_origin_product: origin.product_handle || '',
      _koota_tracking_session: sessionId()
    };
    if (marketingAllowed()) {
      CLICK_ID_KEYS.forEach(function (key) {
        if (last[key]) attributes['_koota_' + key] = last[key];
      });
    }

    var schedule = window.requestIdleCallback || function (callback) { window.setTimeout(callback, 1200); };
    schedule(function () {
      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ attributes: attributes })
      }).then(function (response) {
        if (response.ok) storageSet('koota_cart_attribution_synced', 'true', true);
      }).catch(function () {});
    });
  }

  function consentUpdated() {
    if (analyticsAllowed()) flush();
  }

  window.KootaTracking = Object.freeze({
    version: VERSION,
    track: emit,
    getAttribution: function () {
      if (!analyticsAllowed()) {
        return {
          firstTouch: { landing_path: currentTouch.landing_path },
          lastTouch: { landing_path: currentTouch.landing_path }
        };
      }
      return attribution || buildAttribution();
    },
    consent: function () {
      return {
        analytics: analyticsAllowed(),
        marketing: marketingAllowed()
      };
    }
  });

  function init() {
    if (initialized) return;
    initialized = true;
    if (analyticsAllowed()) {
      loadGTM();
      buildAttribution();
    }
    setupSections();
    setupInteractions();
    setupScrollAndEngagement();
    emit('koota_tracking_ready', { tracking_version: VERSION });
    if (analyticsAllowed()) flush();
  }

  document.addEventListener('koota:consent:update', consentUpdated);
  document.addEventListener('visitorConsentCollected', consentUpdated);

  if (window.KootaConsent && typeof window.KootaConsent.onChange === 'function') {
    window.KootaConsent.onChange(consentUpdated);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
